import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { userAtom } from '@root/entities/auth'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { Error } from '@root/shared'
import { reatomRequest } from '@root/shared/lib'
import { showErrorCodeSnackbarAction } from '@root/shared/ui'

import { SecureStorageError, toSharedErrorCode } from '../secure-storage-error'

import { refreshSecureStorageStateAction } from './reatom-secure-storage-state'

import type { Redacted } from '@blade/std-lib'

export const initializeSecureStorageAction = action(
  async (ctx, { password }: { password: Redacted.Redacted }) => {
    const { secureStorageService } = ctx.get(dependenciesAtom)
    const currentUser = ctx.get(userAtom)

    if (!currentUser) {
      return Result.fail(
        SecureStorageError.fromUnknown(Error.UnknownError.fromUnknown()),
      )
    }

    const result = await ctx.schedule(() =>
      secureStorageService.initialize(currentUser.delugeId, password),
    )

    if (Result.isFailure(result)) {
      return Result.fail(SecureStorageError.fromUnknown(result.failure))
    }

    await ctx.schedule(() => refreshSecureStorageStateAction(ctx))
    return Result.succeed(undefined)
  },
  'initializeSecureStorageAction',
)

export const reatomInitializeSecureStorage = () => {
  const theAtom = reatomRequest({
    execAction: initializeSecureStorageAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'initializeSecureStorage',
    onResult: (ctx, result) => {
      if (Result.isFailure(result)) {
        showErrorCodeSnackbarAction(ctx, toSharedErrorCode(result.failure))
        return
      }
    },
  })

  return theAtom
}
